<template>
  <CommonList
    selection-type="radio"
    row-key="id"
    :has-more-search="false"
    :auto-load="true"
    ref="listRef"
    cell-overflow="ellipsis"
    @selection-change="handleSelectionChange"
    @current-row-change="handleCurrentRowChange"
    @load-start="handleLoadList"
    @search-click="handleLoadList"
    @pagination-change="handleLoadList"
    @reset-click="handleReset"
  >
    <template #search-item-fixed>
      <div class="common-search-item">
        <label class="common-search-label80">物品名称:</label>
        <el-input v-model="searchForm.itemName" class="common-input150" placeholder="请输入"></el-input>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">状态:</label>
        <el-select v-model="searchForm.status" class="common-input120" placeholder="请选择" clearable>
          <el-option label="上架" value="1"></el-option>
          <el-option label="下架" value="0"></el-option>
        </el-select>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">物品类型:</label>
        <el-select v-model="searchForm.exchangeType" class="common-input120" placeholder="请选择" clearable>
          <el-option label="普通兑换" value="0"></el-option>
          <el-option label="福利赠送" value="1"></el-option>
        </el-select>
      </div>
    </template>

    <template #btn-group>
      <el-button type="primary" class="list-btn" @click="handleAdd">
        <el-icon><Plus/></el-icon>
        新增
      </el-button>
      <el-button
        type="warning"
        class="list-btn"
        @click="handleEdit"
        :disabled="!listShow"
      >
        <el-icon><Edit/></el-icon>
        修改
      </el-button>
      <el-button
        type="info"
        class="list-btn"
        @click="handleView"
        :disabled="!listShow"
      >
        <el-icon><View/></el-icon>
        查看
      </el-button>
      <el-button
        type="danger"
        class="list-btn"
        @click="handleDelete"
        :disabled="!listShow"
      >
        <el-icon><Delete/></el-icon>
        删除
      </el-button>
    </template>

    <template #table-column>
      <el-table-column prop="itemId" label="物品编号" align="center" width="200"></el-table-column>
      <el-table-column prop="itemName" label="物品名称" align="center" min-width="150"></el-table-column>
      <el-table-column prop="itemValue" label="物品价值(元)" align="center" width="120"></el-table-column>
      <el-table-column prop="requiredPoints" label="所需积分" align="center" width="100"></el-table-column>
      <el-table-column prop="expressSupport" label="支持快递" align="center" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.expressSupport === '1' ? 'success' : 'info'">
            {{ scope.row.expressSupport === '1' ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="库存" align="center" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.quantity > 0 ? 'success' : 'danger'">
            {{ scope.row.quantity }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.status === '1' ? 'success' : 'info'">
            {{ scope.row.status === '1' ? '上架' : '下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="exchangeType" label="物品类型" align="center" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.exchangeType === '1' ? 'warning' : 'primary'">
            {{ scope.row.exchangeType === '1' ? '福利赠送' : '普通兑换' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="180">
        <template #default="scope">
          {{ $formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>
    </template>

    <template #extra>
      <el-dialog
        v-model="dialogVisible"
        :title="dialogType === 'add' ? '新增兑换物品' : dialogType === 'edit' ? '修改兑换物品' : '查看兑换物品'"
        width="600px"
        destroy-on-close
      >
        <el-form
          ref="formRef"
          :model="formData"
          :rules="formRules"
          label-width="100px"
          class="list-modal-form"
          :disabled="dialogType === 'view'"
        >
          <el-form-item label="物品编号" v-if="dialogType !== 'add'">
            <el-input v-model="formData.itemId" disabled></el-input>
          </el-form-item>
          <el-form-item label="物品名称" prop="itemName">
            <el-input
              v-model="formData.itemName"
              placeholder="请输入物品名称"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="物品价值" prop="itemValue">
            <el-input-number
              v-model="formData.itemValue"
              :min="0"
              :precision="2"
              style="width: 100%;"
              placeholder="请输入物品价值"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="所需积分" prop="requiredPoints">
            <el-input-number
              v-model="formData.requiredPoints"
              :min="formData.exchangeType === '1' ? 0 : 1"
              style="width: 100%;"
              placeholder="请输入所需积分"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="支持快递" prop="expressSupport">
            <el-radio-group v-model="formData.expressSupport">
              <el-radio value="1">是</el-radio>
              <el-radio value="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="物品数量" prop="quantity">
            <el-input-number
              v-model="formData.quantity"
              :min="0"
              style="width: 100%;"
              placeholder="请输入物品数量"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="formData.status">
              <el-radio value="1">上架</el-radio>
              <el-radio value="0">下架</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="物品类型" prop="exchangeType">
            <el-radio-group v-model="formData.exchangeType">
              <el-radio value="0">普通兑换</el-radio>
              <el-radio value="1">福利赠送</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <template #footer>
          <div style="text-align: center; width: 100%;">
            <el-button @click="dialogVisible = false">{{ dialogType === 'view' ? '关闭' : '取消' }}</el-button>
            <el-button v-if="dialogType !== 'view'" type="primary" @click="handleSubmit">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </template>
  </CommonList>
</template>

<script setup>
import useExchangeItemList from './ExchangeItemList.js';

const {
  searchForm,
  listRef,
  dialogVisible,
  dialogType,
  formRef,
  listShow,
  formData,
  formRules,
  Plus,
  Edit,
  Delete,
  View,
  handleSelectionChange,
  handleCurrentRowChange,
  handleAdd,
  handleEdit,
  handleView,
  handleDelete,
  handleLoadList,
  handleReset,
  handleSubmit
} = useExchangeItemList();
</script>

<style>
@import '../../../assets/css/util/base-list.css';
</style>
